import React from 'react';
import Chip from '@material-ui/core/Chip';

export const DATA_SOURCE_STATUSES = [
    { key: 'active', value: 'Active' },
    { key: 'not_active', value: 'Not Active' },
];

export const DATA_SOURCE_STATUS_LABELS = DATA_SOURCE_STATUSES.reduce(
    (acc, { key, value }) => ({ ...acc, [key]: value }),
    {}
);

const STATUS_COLORS = {
    active: '#4caf50',
    not_active: '#f44336',
};

const DataSourceStatusChip = ({ status }) => {
    const isEmpty = !status || status.toLowerCase() === 'null';
    if (isEmpty) {
        return <Chip label="Not Set" variant="outlined" size="small" style={{ color: '#bdbdbd', borderColor: '#bdbdbd' }} />;
    }
    const normalisedStatus = status.toLowerCase();
    const color = STATUS_COLORS[normalisedStatus] || '#bdbdbd';
    const label = DATA_SOURCE_STATUS_LABELS[normalisedStatus] || status;

    return (
        <Chip
            label={label}
            variant="outlined"
            size="small"
            style={{ color, borderColor: color, fontWeight: 500 }}
        />
    );
};

export default DataSourceStatusChip;
